// source: pbtypes/vehicle/complimentary_actions/complimentary_actions_impls/spoof_multi_drone/spoof_multi_drone.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector3d_pb = require('../../../../../pbtypes/gen/eigen_lcm/Vector3d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector3d_pb);
var pbtypes_vehicle_complimentary_actions_trigger_args_pb = require('../../../../../pbtypes/vehicle/complimentary_actions/trigger_args_pb.js');
goog.object.extend(proto, pbtypes_vehicle_complimentary_actions_trigger_args_pb);
var pbtypes_vehicle_skills_actions_spoof_multi_drone_spoof_multi_drone_pb = require('../../../../../pbtypes/vehicle/skills/actions/spoof_multi_drone/spoof_multi_drone_pb.js');
goog.object.extend(proto, pbtypes_vehicle_skills_actions_spoof_multi_drone_spoof_multi_drone_pb);
goog.exportSymbol('proto.complimentary_actions.SpoofDroneCommand', null, global);
goog.exportSymbol('proto.complimentary_actions.SpoofMultiDroneActionArgs', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.complimentary_actions.SpoofDroneCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.complimentary_actions.SpoofDroneCommand.repeatedFields_, null);
};
goog.inherits(proto.complimentary_actions.SpoofDroneCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.complimentary_actions.SpoofDroneCommand.displayName = 'proto.complimentary_actions.SpoofDroneCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.complimentary_actions.SpoofMultiDroneActionArgs.repeatedFields_, null);
};
goog.inherits(proto.complimentary_actions.SpoofMultiDroneActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.complimentary_actions.SpoofMultiDroneActionArgs.displayName = 'proto.complimentary_actions.SpoofMultiDroneActionArgs';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.complimentary_actions.SpoofDroneCommand.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.complimentary_actions.SpoofDroneCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.complimentary_actions.SpoofDroneCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.complimentary_actions.SpoofDroneCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.SpoofDroneCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
durationS: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
spoofedDronesList: jspb.Message.toObjectList(msg.getSpoofedDronesList(),
    pbtypes_vehicle_skills_actions_spoof_multi_drone_spoof_multi_drone_pb.SpoofDroneRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.complimentary_actions.SpoofDroneCommand}
 */
proto.complimentary_actions.SpoofDroneCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.complimentary_actions.SpoofDroneCommand;
  return proto.complimentary_actions.SpoofDroneCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.complimentary_actions.SpoofDroneCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.complimentary_actions.SpoofDroneCommand}
 */
proto.complimentary_actions.SpoofDroneCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDurationS(value);
      break;
    case 2:
      var value = new pbtypes_vehicle_skills_actions_spoof_multi_drone_spoof_multi_drone_pb.SpoofDroneRequest;
      reader.readMessage(value,pbtypes_vehicle_skills_actions_spoof_multi_drone_spoof_multi_drone_pb.SpoofDroneRequest.deserializeBinaryFromReader);
      msg.addSpoofedDrones(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.complimentary_actions.SpoofDroneCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.complimentary_actions.SpoofDroneCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.complimentary_actions.SpoofDroneCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.SpoofDroneCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDurationS();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getSpoofedDronesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      pbtypes_vehicle_skills_actions_spoof_multi_drone_spoof_multi_drone_pb.SpoofDroneRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional float duration_s = 1;
 * @return {number}
 */
proto.complimentary_actions.SpoofDroneCommand.prototype.getDurationS = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.complimentary_actions.SpoofDroneCommand} returns this
 */
proto.complimentary_actions.SpoofDroneCommand.prototype.setDurationS = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * repeated skills.SpoofDroneRequest spoofed_drones = 2;
 * @return {!Array<!proto.skills.SpoofDroneRequest>}
 */
proto.complimentary_actions.SpoofDroneCommand.prototype.getSpoofedDronesList = function() {
  return /** @type{!Array<!proto.skills.SpoofDroneRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_vehicle_skills_actions_spoof_multi_drone_spoof_multi_drone_pb.SpoofDroneRequest, 2));
};


/**
 * @param {!Array<!proto.skills.SpoofDroneRequest>} value
 * @return {!proto.complimentary_actions.SpoofDroneCommand} returns this
*/
proto.complimentary_actions.SpoofDroneCommand.prototype.setSpoofedDronesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.skills.SpoofDroneRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.skills.SpoofDroneRequest}
 */
proto.complimentary_actions.SpoofDroneCommand.prototype.addSpoofedDrones = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.skills.SpoofDroneRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.complimentary_actions.SpoofDroneCommand} returns this
 */
proto.complimentary_actions.SpoofDroneCommand.prototype.clearSpoofedDronesList = function() {
  return this.setSpoofedDronesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.complimentary_actions.SpoofMultiDroneActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.complimentary_actions.SpoofMultiDroneActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
trigger: (f = msg.getTrigger()) && pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback.toObject(includeInstance, f),
spoofDroneCommandsList: jspb.Message.toObjectList(msg.getSpoofDroneCommandsList(),
    proto.complimentary_actions.SpoofDroneCommand.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.complimentary_actions.SpoofMultiDroneActionArgs}
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.complimentary_actions.SpoofMultiDroneActionArgs;
  return proto.complimentary_actions.SpoofMultiDroneActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.complimentary_actions.SpoofMultiDroneActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.complimentary_actions.SpoofMultiDroneActionArgs}
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback;
      reader.readMessage(value,pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback.deserializeBinaryFromReader);
      msg.setTrigger(value);
      break;
    case 2:
      var value = new proto.complimentary_actions.SpoofDroneCommand;
      reader.readMessage(value,proto.complimentary_actions.SpoofDroneCommand.deserializeBinaryFromReader);
      msg.addSpoofDroneCommands(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.complimentary_actions.SpoofMultiDroneActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.complimentary_actions.SpoofMultiDroneActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrigger();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback.serializeBinaryToWriter
    );
  }
  f = message.getSpoofDroneCommandsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.complimentary_actions.SpoofDroneCommand.serializeBinaryToWriter
    );
  }
};


/**
 * optional TriggerArgs.TimerCallback trigger = 1;
 * @return {?proto.complimentary_actions.TriggerArgs.TimerCallback}
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs.prototype.getTrigger = function() {
  return /** @type{?proto.complimentary_actions.TriggerArgs.TimerCallback} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_complimentary_actions_trigger_args_pb.TriggerArgs.TimerCallback, 1));
};


/**
 * @param {?proto.complimentary_actions.TriggerArgs.TimerCallback|undefined} value
 * @return {!proto.complimentary_actions.SpoofMultiDroneActionArgs} returns this
*/
proto.complimentary_actions.SpoofMultiDroneActionArgs.prototype.setTrigger = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.complimentary_actions.SpoofMultiDroneActionArgs} returns this
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs.prototype.clearTrigger = function() {
  return this.setTrigger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs.prototype.hasTrigger = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated SpoofDroneCommand spoof_drone_commands = 2;
 * @return {!Array<!proto.complimentary_actions.SpoofDroneCommand>}
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs.prototype.getSpoofDroneCommandsList = function() {
  return /** @type{!Array<!proto.complimentary_actions.SpoofDroneCommand>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.complimentary_actions.SpoofDroneCommand, 2));
};


/**
 * @param {!Array<!proto.complimentary_actions.SpoofDroneCommand>} value
 * @return {!proto.complimentary_actions.SpoofMultiDroneActionArgs} returns this
*/
proto.complimentary_actions.SpoofMultiDroneActionArgs.prototype.setSpoofDroneCommandsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.complimentary_actions.SpoofDroneCommand=} opt_value
 * @param {number=} opt_index
 * @return {!proto.complimentary_actions.SpoofDroneCommand}
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs.prototype.addSpoofDroneCommands = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.complimentary_actions.SpoofDroneCommand, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.complimentary_actions.SpoofMultiDroneActionArgs} returns this
 */
proto.complimentary_actions.SpoofMultiDroneActionArgs.prototype.clearSpoofDroneCommandsList = function() {
  return this.setSpoofDroneCommandsList([]);
};


goog.object.extend(exports, proto.complimentary_actions);
